<form #OBJ_form="ngForm" class="form-horizontal">
	<!--Iterate over normal fields-->
	<ng-container *ngFor="let OBJ_config_field of OBJ_config_fields?.fields">
		<ng-container [ngSwitch]="OBJ_config_field.type">
			<ng-container *ngSwitchCase="'input'">
				<tig-input [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_assignment"></tig-input>
			</ng-container>
			<ng-container *ngSwitchCase="'textarea'">
				<tig-textarea [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_assignment"></tig-textarea>
			</ng-container>
			<ng-container *ngSwitchCase="'select'">
				<tig-assignment-select-component [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_assignment"></tig-assignment-select-component>
			</ng-container>
			<ng-container *ngSwitchCase="'select_multiple_check'">
				<tig-select-multiple [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_assignment"></tig-select-multiple>
			</ng-container>
		</ng-container>
	</ng-container>
	<!--Iterate over assignments-->
	<ng-container *ngFor="let OBJ_config_field of OBJ_assignment_config?.fields">
		<ng-container [ngSwitch]="OBJ_config_field.type">
			<ng-container *ngSwitchCase="'select'">
				<tig-assignment-select-component [OBJ_field_config]="OBJ_config_field" [OBJ_data]="findAssignmentByTitle(OBJ_config_field.name)"></tig-assignment-select-component>
			</ng-container>
			<ng-container *ngSwitchCase="'select_multiple_check'">
				<tig-select-multiple [OBJ_field_config]="OBJ_config_field" [OBJ_data]="findAssignmentByTitle(OBJ_config_field.name)"></tig-select-multiple>
			</ng-container>
			<ng-container *ngSwitchCase="'object'">
				<ng-container *ngFor="let OBJ_config_field_assignment of OBJ_config_field?.fields">
					<ng-container [ngSwitch]="OBJ_config_field_assignment.type">
						<ng-container *ngSwitchCase="'select'">
							<tig-assignment-select-component [OBJ_field_config]="OBJ_config_field_assignment" [OBJ_data]="findAssignmentByTitle(OBJ_config_field.name)"></tig-assignment-select-component>
						</ng-container>
						<ng-container *ngSwitchCase="'select_multiple_check'">
							<tig-select-multiple [OBJ_field_config]="OBJ_config_field_assignment" [OBJ_data]="findAssignmentByTitle(OBJ_config_field.name)"></tig-select-multiple>
						</ng-container>
					</ng-container>
				</ng-container>
			</ng-container>
		</ng-container>
	</ng-container>
</form>